import React from "react";
import {cl} from '../../components/utils/utils';

class C18GoogleMap00 extends React.Component {

  constructor(props) {
    super(props);
    this.markerMap = new Map(); // id → Marker
  }

  componentDidMount() {
    const center={lat:+this.props.lat,lng:+this.props.lng}
    this.geocoder=new window.google.maps.Geocoder()
//     cl("set map")
    this.map = new window.google.maps.Map(
      document.getElementById("map"),
      {
        center:center,
        zoom: +this.props.zoom,
        mapId:"roadmap",
        mapTypeId: "hybrid",
        gestureHandling: "greedy",// 20260302
        disableDefaultUI: true,
        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            west: -180,
            east: 180,
          },
          strictBounds: true,
        }
      }
    );
//     cl("set map")
  }

  addName=(m,markerDiv)=>{
//     cl(m.name)
    // container to stack icon + label
    markerDiv.style.display = "flex";
    markerDiv.style.flexDirection = "column";
    markerDiv.style.alignItems = "center";

    // SVG icon
    const iconDiv = document.createElement("div");
    iconDiv.innerHTML = m.svg;
    iconDiv.style.filter = "drop-shadow(2px 2px 0px black)";
    if(m.title){iconDiv.title=m.title}

    // label
    const labelDiv = document.createElement("div");
    labelDiv.textContent = m.name;   // ← marker name
//     labelDiv.style.marginTop = "4px";
    labelDiv.style.fontSize = "18px";
    labelDiv.style.fontWeight = "500";
    labelDiv.style.color = "white";
    labelDiv.style.whiteSpace = "nowrap";
    labelDiv.style.textShadow = "2px 2px 1px black";

    // assemble
    markerDiv.appendChild(labelDiv);
    markerDiv.appendChild(iconDiv);

  }

  // PUBLIC API
  setMarkers(markers) {
//     cl("setMarkers")
//     cl(markers)
    const nextIds = new Set(markers.map(m => m.id));
//     cl(nextIds)
//     cl(this.markerMap)
    // remove missing
    this.markerMap.forEach((marker, id) => {
//       cl(id)
      if (!nextIds.has(id)) {
        marker.setMap(null);
        this.markerMap.delete(id);
      }
    });

    // add / update
    markers.forEach(m => {
      const markerDiv = document.createElement("div");
      markerDiv.style.transform = "translate(0, 12px)";
      markerDiv.style.color=m.color
      markerDiv.className = "marker";
//       markerDiv.innerHTML = m.svg
      this.addName(m,markerDiv)

//       cl(m.title)
      let marker = this.markerMap.get(m.id);
      if (!marker) {
//         cl("new marker")
        marker = new window.google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: {lat:m.lat,lng:m.lng},
          content: markerDiv,
          gmpDraggable: m.draggable,
        });
        this.markerMap.set(m.id, marker);

        marker.addListener("dragend", (e) => {
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();

          if (this.props.onMarkerMove) {
            this.props.onMarkerMove({ id:m.id, lat, lng });
          }
        })
        marker.addListener("gmp-click", (e) => {
//           cl(e)
          if (this.props.onMarkerClick) {
            this.props.onMarkerClick({ e:e.domEvent, id:m.id });
          }
        })
        this.map.addListener("mousemove", (e) => {
          if (this.props.onMouseMove) {
            this.props.onMouseMove({ lat:e.latLng.lat(),lng:e.latLng.lng() });
          }
        })
        this.map.addListener("idle", (e) => {
          if (this.props.onIdle) {
            const center = this.map.getCenter();
//             cl(this.map.getZoom())
            this.props.onIdle({ lat:center.lat(),lng:center.lng() });
          }
        })
      }else{
        marker.content.style.color=m.color
        marker.gmpDraggable=m.draggable
      }

    });
//     cl("setMarkers")
  }

  clearMarkers() {
    this.markerMap.forEach(marker => marker.setMap(null));
    this.markerMap.clear();
  }

  geocode(addr){
    this.geocoder.geocode(
      { address: addr },
      (results, status) => {
        if (status === "OK") {
          const loc = results[0].geometry.location;
          return({lat:loc.lat(),lng:loc.lng()})
//           this.map.setCenter(loc);
//           console.log(loc.lat(), loc.lng());
        }
      }
    );
  }

  setCenterBounds=(latLng,minMax)=>{
//     this.map.setCenter(latLng)
//     this.map.setZoom(6)
//     cl(minMax)
//     return
//     cl("setCenterBounds")
//     cl(latLng)
//     cl(minMax)
    if(minMax){
      if((minMax.latMax||0)<=(minMax.latMin||0)){
        minMax.latMax=latLng.lat+.01
        minMax.latMin=latLng.lat-.01
        minMax.lngMax=latLng.lng+.01
        minMax.lngMin=latLng.lng-.01
      }
//       cl(minMax)
      let bounds=new window.google.maps.LatLngBounds(
        {lat:minMax.latMin,lng:minMax.lngMin},
        {lat:minMax.latMax,lng:minMax.lngMax}
      )
      this.map.fitBounds(bounds)
    }else{
      cl(latLng)
      this.map.setCenter(latLng)
    }
//     cl("setCenterBounds")
  }

  render() {
//     cl("renderMap")
    return (
      <div
        id="map"
        style={{ width: this.props.wid, height: this.props.hgt }}
      />
    );
  }
}

export default C18GoogleMap00;
